module.exports = __webpack_public_path__ + "static/media/reset-coinera.63ec8517.svg";